// extracted by mini-css-extract-plugin
export default {"forgotPasswordForm":"styles_forgotPasswordForm__Dz9YC","errorMessage":"styles_errorMessage__isGGm","successMessage":"styles_successMessage__3BTKI"};